import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { useSelf } from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import * as contactHooks from "@rentiohq/shared-frontend/dist/redux/contact/contact.hooks";
import * as contactSelectors from "@rentiohq/shared-frontend/dist/redux/contact/contact.selectors";
import {
  Card,
  Loading,
  ResourceList,
} from "@rentiohq/web-shared/dist/components";
import { ContactOverviewRow } from "@rentiohq/web-shared/dist/components/ContactOverviewRow/ContactOverviewRow";
import { compact } from "lodash";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { IRootStore } from "redux/reducers";

export const DuplicateContacts = () => {
  const params = useParams<{ contactId: string }>();
  const contactId = params.contactId ? +params.contactId : undefined;

  const { broker } = useSelf();

  const contact = useSelector((state: IRootStore) =>
    contactId ? contactSelectors.getContact(state, contactId) : undefined,
  );

  const { data: duplicateContacts, isFetching: isFetchingDuplicateContacts } =
    contactHooks.usePaged(
      contact
        ? {
            shouldRefetch: true,
            page: 1,
            limit: CONFIG.DEFAULT_FETCH_LIMIT,
            filter: {
              where: {
                and: [
                  {
                    or: compact([
                      contact.email !== broker?.dummyEmail
                        ? { email: contact.email }
                        : undefined,
                      contact.phone !== broker?.dummyPhone
                        ? { phone: contact.phone }
                        : undefined,
                    ]),
                  },
                  { id: { neq: contact.id } },
                ],
              },
            },
          }
        : {
            shouldRefetch: false,
          },
    );

  // Render
  if (!contact) {
    return null;
  }

  const renderContactItem = (item: any) => (
    <ContactOverviewRow contact={item} clickable={true} />
  );

  return (
    <Card>
      {isFetchingDuplicateContacts &&
        (duplicateContacts || []).length === 0 && <Loading />}

      <ResourceList
        items={duplicateContacts || []}
        renderItem={renderContactItem}
      />
    </Card>
  );
};
